import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { Auth0Provider } from '@auth0/auth0-react';
import { Auth0DataProvider } from './context/Auth0DataContext';
import { TeamProvider } from './context/TeamContext';
import { ChatProvider } from './context/ChatContext';
import AuthWrapper from './components/Auth/AuthWrapper';
import SessionMonitor from './components/Auth/SessionMonitor';
import Layout from './components/Layout/Layout';
import Dashboard from './pages/Dashboard/Dashboard';
import DataManagement from './pages/DataManagement/DataManagement';
import ProjectManagement from './pages/ProjectManagement/ProjectManagement';
import CRM from './pages/CRM/CRM';
import TeamSettings from './pages/TeamSettings/TeamSettings';
import ChatWidget from './components/Chat/ChatWidget';
import { auth0Config } from './lib/auth0';
import './App.css';

function App() {
  return (
    <Auth0Provider
      domain={auth0Config.domain}
      clientId={auth0Config.clientId}
      authorizationParams={auth0Config.authorizationParams}
      cacheLocation={auth0Config.cacheLocation}
      useRefreshTokens={auth0Config.useRefreshTokens}
    >
      <Auth0DataProvider>
        <TeamProvider>
          <ChatProvider>
            <Router>
              <div className="min-h-screen bg-gray-50">
                <AuthWrapper>
                  <SessionMonitor>
                    <Layout>
                      <Routes>
                        <Route path="/" element={<Dashboard />} />
                        <Route path="/data-management/*" element={<DataManagement />} />
                        <Route path="/project-management/*" element={<ProjectManagement />} />
                        <Route path="/crm/*" element={<CRM />} />
                        <Route path="/team-settings/*" element={<TeamSettings />} />
                      </Routes>
                    </Layout>
                    <ChatWidget />
                  </SessionMonitor>
                </AuthWrapper>
              </div>
            </Router>
          </ChatProvider>
        </TeamProvider>
      </Auth0DataProvider>
    </Auth0Provider>
  );
}

export default App;